<template>
  <div class='recommend-declare atb-flex atb-flex-column'>
    <div class='tab'>
      <Tabs :tab-list="tabList" :defaultIndex="defaultTab" @getCurrent="getCurrent" />
    </div>
    <div v-show="currentTab == 0" class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search-wrap'>
        <el-form :inline="true" :model="declareForm" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <el-form-item class="form-param-item" label="姓名">
            <selecter v-model="declareForm.ReWkNo" clearable></selecter>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <!-- <el-button type="export" v-if="$auth(that, 'Commit')" @click="commitTip">提交</el-button> -->
            <el-button type="export" @click="commitTip">提交</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="export" @click="exportListExcel">导出</el-button>
          </el-form-item>
          <el-form-item class="multi-line">
            <el-button type="downloadTemplate" @click="downloadTemplate">下载导入模板</el-button>
          </el-form-item>
          <el-form-item>
            <el-upload ref="file" :http-request="uploadPublishFile" :multiple="false" :show-file-list="false">
              <el-button type="export">导入</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button plain type="downloadTemplate" @click="declareExpandRowAll">{{declareExpandRowAllFlag ? "收起全部" : "展开全部"}}</el-button>
          </el-form-item>
          <el-form-item>
            <span style="color: #fe6562;">（注意：评级结果为A或C时必须填写评级原因）</span>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="tableData"
          ref="unHandle"
          :edit-rules="validRules"
          :edit-config="{trigger: 'click', mode: 'row', activeMethod: editActived}"
          @edit-closed="editClosed"
          @cell-click="expandRow"
        >
          <vxe-table-column type="seq" width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="reWkNo" width="140" title="姓名">
             <template #default="{ row }">
              <span>{{row.reWkName? row.reWkName + "("+row.reWkNo+")": row.reWkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="wkNo" title="建议人" width="140">
            <template #default="{ row }">
              <span>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superiorNo" width="140" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220"></vxe-table-column>
          <vxe-table-column field="date" title="年/月" width="80">
            <template #default="{row}">{{row.year + '/' + row.month}}</template>
          </vxe-table-column>
          <vxe-table-column width="90" field="ratingResult" title="建议评级" :edit-render="{name: 'ElSelect', autofocus: '.el-input__inner'}">
            <template #default="{row}">
              <span v-if="row.ratingResult == 'A'" style="color:#22b6a1">{{row.ratingResult}}</span>
              <span v-else-if="row.ratingResult == 'B'">{{row.ratingResult}}</span>
              <span v-else style="color:#fe6562">{{row.ratingResult}}</span>
            </template>
            <template #edit="{row}">
              <el-select v-model="row.ratingResult" @change="$refs.unHandle.updateStatus(scope)">
                <el-option v-for="item in oecLevel" :key="item.label" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column width="110" field="importanceLevel" title="重要性" :edit-render="{name: 'ElSelect', autofocus: '.el-input__inner'}">
            <template #default="{row}">
              <span>{{formatImportance(row.importanceLevel)}}</span>
            </template>
            <template #edit="{row}">
              <el-select v-model="row.importanceLevel" @change="$refs.unHandle.updateStatus(scope)">
                <el-option v-for="item in importanceList" :key="item.itemValue" :label="item.itemDesc" :value="item.itemValue"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="160" field="ratingReason" title="建议原因" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.ratingReason" maxlength="512"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.ratingReason}}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="150" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remarks" maxlength="512"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remarks}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="建议状态" width="140">
            <template #default="{ row }">
              <el-tag class="status-tag" :type="row.status == 0 ? 'unstart' : (row.status == 1 ? 'complete' : 'ongoing') " effect="dark">
                {{ getState(row.status) }}
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column width="200" field="oecRatingResult" title="OEC结果">
            <template #default="{row}">
              <div v-if="row.oecEntity" :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">
                <span>
                  <span v-if="row.oecEntity.ratingResult == 'A'" style="color:#22b6a1">{{row.oecEntity.ratingResult}}</span>
                  <span v-else-if="row.oecEntity.ratingResult == 'B'">{{row.oecEntity.ratingResult}}</span>
                  <span v-else style="color:#fe6562">{{row.oecEntity.ratingResult}}</span>
                </span>
                <el-tag class="oec-result-status" :type="row.oecEntity.status == 0 ? 'unstart' : (row.oecEntity.status == 1 ? 'complete' : 'ongoing') " effect="dark">
                  {{ formatOecStatus(row) }}
                </el-tag>
                <span>{{ row.oecEntity.ratingReason }}</span>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          background
          :current-page.sync="page.PageIndex"
          :page-size.sync="page.PageSize"
          :total="total"
          height="100%"
          @page-change="pageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <div v-if="currentTab == 1" class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="historyForm" class="atb-input" @keyup.enter.native.prevent="getHistoryList(1)" @submit.native.prevent>
          <div class="query-where">
            <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
              <el-popover
                placement="bottom-start"
                width="420"
                popper-class="popper-tree declare-dep"
                @hide="historyHandledHide"
                trigger="click">
                <el-tree
                  :props="defaultProps"
                  :data="historyTreeData"
                  show-checkbox
                  node-key='id'
                  ref="historyTree"
                  highlight-current
                  check-strictly
                  :filter-node-method="filterHistoryDeptNode"
                  :default-expanded-keys="expandedData"
                  @check-change="historyHandleCheckChange">
                </el-tree>
                <el-input slot="reference" v-model="historyDepartment" placeholder="请选择部门名称" clearable></el-input>
              </el-popover>
            </el-form-item>
            <el-form-item class="flex-form-item" label="上级">
              <selecter v-model="historyForm.SuperiorNo" clearable></selecter>
            </el-form-item>
            <el-form-item class="flex-form-item" label="姓名">
              <selecter v-model="historyForm.ReWkNo" clearable></selecter>
            </el-form-item>
            <el-form-item class="flex-form-item" label="月份">
              <el-date-picker
                v-model="historyForm.DeclarTime"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择月">
              </el-date-picker>
            </el-form-item>
          </div>
          <div class="query-operation">
            <el-form-item class="flex-form-item" label="建议结果">
              <el-select clearable v-model="historyForm.RatingResult" placeholder="建议结果">
                <el-option v-for="item in oecLevel" :key="item.value" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="flex-form-item" label="建议状态">
              <common-select ref="status" v-model="historyForm.Status" :list="stateList" optLabel="itemDesc" optValue="itemValue" placeholder="建议状态" clearable></common-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getHistoryList(1)">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="exportHistoryExcel">导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="downloadTemplate" @click="exportMulti">批量导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button plain type="downloadTemplate" @click="historyExpandRowAll">{{historyExpandRowAllFlag ? "收起全部" : "展开全部"}}</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table'
          border='inner'
          height='100%'
          ref="handled"
          auto-resize
          highlight-hover-row
          highlight-current-row
          :data="historyData"
          @cell-click="historyExpandRow"
        >
          <vxe-table-column type="seq" width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="reWkNo" title="姓名" width="140">
            <template #default="{ row }">
              <span>{{row.reWkName? row.reWkName + "("+row.reWkNo+")": row.reWkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="wkNo" title="建议人" width="140">
            <template #default="{ row }">
              <span>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superiorNo" title="上级" width="140">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220">
            <template #default="{row}">{{row.department}}</template>
          </vxe-table-column>
          <vxe-table-column field="date" title="年/月" width="80">
            <template #default="{row}">{{row.year+'/'+row.month}}</template>
          </vxe-table-column>
          <vxe-table-column field="ratingResult" title="建议结果" width="100">
             <template #default="{row}">{{row.ratingResult}}</template>
          </vxe-table-column>
          <vxe-table-column width="110" field="importanceLevel" title="重要性">
            <template #default="{row}">
              <span>{{formatImportance(row.importanceLevel)}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="ratingReason" title="建议原因" min-width="200">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.ratingReason}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" title="备注" min-width="150">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remarks}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="建议状态" width="140" align="center">
            <template #default="{ row }">
              <el-tag :type="row.status == 0 ? 'unstart' : (row.status == 1 ? 'complete' : 'ongoing') " effect="dark">
                {{ getState(row.status) }}
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column width="200" field="oecRatingResult" title="OEC结果">
            <template #default="{row}">
              <div v-if="row.oecEntity" :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">
                <span>
                  <span v-if="row.oecEntity.ratingResult == 'A'" style="color:#22b6a1">{{row.oecEntity.ratingResult}}</span>
                  <span v-else-if="row.oecEntity.ratingResult == 'B'">{{row.oecEntity.ratingResult}}</span>
                  <span v-else style="color:#fe6562">{{row.oecEntity.ratingResult}}</span>
                </span>
                <el-tag class="oec-result-status" :type="row.oecEntity.status == 0 ? 'unstart' : (row.oecEntity.status == 1 ? 'complete' : 'ongoing') " effect="dark">
                  {{ formatOecStatus(row) }}
                </el-tag>
                <span>{{ row.oecEntity.ratingReason }}</span>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          background
          :current-page.sync="historyPage.PageIndex"
          :page-size.sync="historyPage.PageSize"
          :total="historyTotal"
          height="100%"
          @page-change="historyPageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes','Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="showCommitTip" width="360px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2 style="line-height: 1.5;">请确认OEC建议填写正确性，提交之后无法修改，无法撤回。确定要提交吗？</h2>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="submit()">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showCommitTip = false">取消</el-button>
      </span>
    </el-dialog>
    
    <common-dialog ref="addDialog" :title="dialogContent.title" :width="dialogContent.width" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :param="Object.assign(this.historyForm, {departmentNo: this.historyDepartmentNo, LoginWkNo: this.currWkNo})"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils'
  import _ from 'lodash';

  export default {
    components: {
      selecter: () => import('@/component/global/customerSelect'),
      month:()=>import('./month.vue'),
    },
    name: "recommend-declare",
    inject: ['reload'],
    data() {
      const ratingReasonValid = ({cellValue, row}) => {
        if (!cellValue && ['A', 'C'].includes(row.ratingResult)) {
          return new Error('评级结果为A、C时必须填写原因！')
        }
      }
      const importanceLevelValid = ({cellValue, row}) => {
        if ((row.status == '0' || row.status == '5') && !cellValue) {
          return new Error('"重要性"为必填项!')
        }
      }
      return {
        that: this,
        validRules: {
          ratingReason: [{validator: ratingReasonValid}],
          importanceLevel: [{required: true, validator: importanceLevelValid}],
        },
        XEUtils: XEUtils,
        currentTab: 0,
        defaultTab: 0,
        tabList: [
          {
            label: '建议申报',
            id: 0,
          },
          {
            label: '建议查询',
            id: 1,
          },
        ],
        oecLevel: [
          {label: 'A'},
          {label: 'B'},
          {label: 'C'},
        ],
        declareForm: {
          ReWkNo: ''
        },
        page: {
          PageIndex: 1,
          PageSize: 10
        },
        total: 0,
        tableData: [],
        stateList: [],

        historyForm: {
          DeclarTime: '',
          ReWkNo: '',
          SuperiorNo: '',
          RatingResult: '',
          Status: '',
        },
        historyPage: {
          PageIndex: 1,
          PageSize: 10
        },
        historyTotal: 0,
        historyData: [],

        depData: [],
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        depList: [],
        checkId: "",
        historyCheckId: "",
        department: '',
        historyDepartment: '',
        copyTreeData: [],
        departmentNo: '',
        historyDepartmentNo: '',
        row: {},
        showCommitTip: false,
        expandedData: [],
        historyTreeData: [],
        historyCopyTreeData: [],
        message: '',
        currWkNo: '',
        editJson: {},
        cacheEditJson: {},
        errMap: 1,
        wkNo: '',
        msgId: '',
        role: 1,
        status: '',
        month: '',
        dialogContent: {},
        oecStatusList: [],
        importanceList: [],
        isEditing: false,
        isEditable: true,
        declareExpandRowAllFlag: false,
        historyExpandRowAllFlag: false,
      }
    },
    mounted() {
      this.currentTab = this.defaultTab = this.$route.query.tab ? +this.$route.query.tab : 0;
      this.historyForm.DeclarTime = this.$route.query.date ? this.$route.query.date : '';
      const userInfo = sessionStorage.getItem('userInfo');
      this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';

      if (this.currentTab === 0) {
        this.getList();
      } else if(this.currentTab === 1) {
        this.getHistoryList();
      }
      
      this.getStatus();
      this.getOecStatus();
      this.getDep();
      this.getImportanceList();
    },
    methods: {
      async getStatus() {
        await this.$ajax.get(this.$api.common.getDict, {ItemType: 'OECRecommendDeclare'}).then((res) => {
          this.stateList = res.data.rows || res.data || [];
        });
      },
      getState(status) {
        const item = this.stateList.find(t => t.itemValue == status);
        return item ? item.itemDesc : '';
      },

      handleClick(tab, event) {
        console.log(tab, event);
      },
      async getList(resetPage) {
        if (resetPage) {
          this.page.PageIndex = 1;
        }
        let param = {};
        param = Object.assign({}, this.page, this.declareForm);

        await this.$ajax.get(this.$api.manage.recommendDeclare.list, param).then(async(res) => {
          this.tableData = res.data.rows || [];
          this.isEditable = res.data.isEdit;
          this.tableData.forEach(item => {
            item.importanceLevel = item.importanceLevel ? '' + item.importanceLevel : item.importanceLevel;
          })
          this.total = res.data.total;
        });
      },

      getHistoryList(resetPage) {
        if (resetPage) {
          this.historyPage.PageIndex = 1;
        }
        let param = Object.assign({}, this.historyPage, this.historyForm, {departmentNo: this.historyDepartmentNo, LoginWkNo: this.currWkNo});
        this.$ajax.get(this.$api.manage.recommendDeclare.historyList, param).then(async(res) => {
          this.historyData = res.data.rows || [];
          this.historyTotal = res.data.total;
        });
      },
      getCurrent(item) {
        this.currentTab = item.data.id;
        if (this.currentTab === 0) {
          this.getList();
        } else if(this.currentTab === 1) {
          this.getHistoryList();
        }
      },
      async editClosed({row}) {
        this.isEditing = false;
        this.errMap = null;
        this.editJson = JSON.parse(JSON.stringify(row));
        const currVal = {ratingResult: row.ratingResult, importanceLevel: row.importanceLevel, ratingReason: row.ratingReason, remarks: row.remarks};
        if (JSON.stringify(this.cacheEditJson) === JSON.stringify(currVal)) {
          this.errMap = 1;
          return;
        }
        this.errMap = await this.$refs.unHandle.validate(row).catch(errMap => errMap)
        if (!this.errMap) {
          this.errMap = 1;
          const {id, ratingResult, importanceLevel, ratingReason, remarks} = row;
          this.$ajax.post(this.$api.manage.recommendDeclare.update, {id, ratingResult, importanceLevel, ratingReason, remarks}).then(async() => {
            this.$message.success("保存成功");
          });
        }
      },
      editActived({row}) {
        if (!this.isEditable) {
          this.$message.error("超时不允许填写");
          return false;
        }
        if (this.msgId && this.wkNo) {
          return false
        }
        if (row.status === 0 && this.errMap) {
          this.isEditing = true;
          const preVal = {ratingResult: row.ratingResult, importanceLevel: row.importanceLevel, ratingReason: row.ratingReason, remarks: row.remarks};
          this.cacheEditJson = JSON.parse(JSON.stringify(preVal));
          return true;
        }
        return false;
      },
      save() {
        if (this.unHandleList.length) {
          this.$ajax.post(this.$api.manage.declare.createAll, this.unHandleList).then(() => {
            this.$message.success("保存成功");
          });
        } else {
          this.$ajax.post(this.$api.manage.declare.createAll, this.tableData).then(() => {
            this.$message.success("保存成功");
          });
        }
      },
      commitTip() {
        if (this.isEditable) {
          this.$nextTick(async () => {
            const errMap = await this.$refs.unHandle.validate(true).catch(errMap => errMap)
            if (!errMap) {
              this.showCommitTip = true;
            }
          })
        } else {
          this.showCommitTip = true;
        }

      },
      submit() {
        this.$ajax.post(this.$api.manage.recommendDeclare.commit, this.declareForm).then(() => {
          this.getList(1);
          this.$message.success("提交成功");
        }).finally(() => {
          this.showCommitTip = false;
        });
      },
   
      pageChange({currentPage}) {
        this.page.PageIndex = currentPage;
        this.getList();
      },
      historyPageChange({currentPage}) {
        this.historyPage.PageIndex = currentPage;
        this.getHistoryList();
      },


      // eslint-disable-next-line no-unused-vars
      expandRow({row}) {
        if (this.isEditing) return;
        row.expandRowFlag = !row.expandRowFlag;
        this.$refs.unHandle.updateData(this.tableData);
      },
      // eslint-disable-next-line no-unused-vars
      historyExpandRow({row, rowIndex}) {
        this.historyData[rowIndex].expandRowFlag = !this.historyData[rowIndex].expandRowFlag;
        this.$refs.handled.updateData(this.historyData);
      },
      async getDep() {
        await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then(res => {
          this.depList = res.data || [];
          const obj = {};
          this.depList.forEach(v => {
            const objClone = _.cloneDeep(obj);
            objClone.id = v.id,
                objClone.code = v.code,
                objClone.label = v.displayName
            if (v.parentId === null) {
              this.expandedData.push(v.id);
              objClone.children = this.depList.filter(t => t.parentId === v.id);
              this.generateMenu(objClone.children);
              this.treeData.push(objClone);
              this.copyTreeData = _.cloneDeep(this.treeData);
              this.historyTreeData.push(objClone);
              this.historyCopyTreeData = _.cloneDeep(this.historyTreeData);
            }
          });
        });
      },
      generateMenu(chs) {
        chs.forEach(v => {
          v.label = v.displayName
          v.children = this.depList.filter(t => t.parentId === v.id)
          this.generateMenu(v.children);
        });
      },
      handleCheckChange(data, checked) {
        if (checked === true) {
          this.checkId = data.id;
          this.departmentNo = data.code;
          this.department = data.label;
          this.$refs.tree.setCheckedKeys([data.id]);
        } else {
          if (this.checkId === data.id) {
            this.checkId = '';
            this.departmentNo = '';
            this.department = '';
            this.$refs.tree.setCheckedKeys([]);
          }
        }
      },
      filterHistoryDeptNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      foldHistoryTree() {
        let treeList = this.historyTreeData;
        //关键代码
          for (let i = 0; i < treeList.length; i++) {
            this.$refs.historyTree.store.nodesMap[treeList[i].id].expanded = false;
          }
      },
      historyHandleCheckChange(data, checked) {
        if (checked === true) {
          this.historyCheckId = data.id;
          this.historyDepartmentNo = data.code;
          this.historyDepartment = data.label
          this.$refs.historyTree.setCheckedKeys([data.id]);
        } else {
          if (this.historyCheckId === data.id) {
            this.historyCheckId = "";
            this.historyDepartmentNo = "";
            this.historyDepartment = "";
            this.$refs.historyTree.setCheckedKeys([]);
          }
        }
      },
      getChildrenMenu(depData) {
        let depTree = [];
        depData.forEach(t => {
          if (t.label.indexOf(this.department) != -1) {
            depTree.push(t)
          } else {
            if (t.children && t.children && t.children.length) {
              t.children = this.getChildrenMenu(t.children)
              if (t.children && t.children.length) {
                depTree.push(t)
              }
            }
          }
        });
        return this.treeData = depTree;
      },
      getHistoryChildrenMenu(depData) {
        let depTree = [];
        depData.forEach(t => {
          if (t.label.indexOf(this.historyDepartment) != -1) {
            depTree.push(t)
          } else {
            if (t.children && t.children && t.children.length) {
              t.children = this.getHistoryChildrenMenu(t.children)
              if (t.children && t.children.length) {
                depTree.push(t)
              }
            }
          }
        });
        return this.historyTreeData = depTree;
      },


      exportListExcel() {
        this.$ajax.get(this.$api.manage.recommendDeclare.exportList, this.declareForm, {ignore: true, responseType: 'blob'}).then((res) => {
          if (res.data.type == 'application/json') {
            var reader = new FileReader();
            reader.onload = () => {
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          } else {
            const filename = 'OEC建议申报'
            const filetype = 'xlsx'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        });
      },

      exportHistoryExcel() {
        this.$ajax.get(this.$api.manage.recommendDeclare.exportHistory, {...this.historyForm, departmentNo: this.historyDepartmentNo, LoginWkNo: this.currWkNo}, {ignore: true, responseType: 'blob'}).then((res) => {
          if (res.data.type == 'application/json') {
            var reader = new FileReader();
            reader.onload = () => {
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          } else {
            const filename = 'OEC建议查询数据'
            const filetype = 'xlsx'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        });
      },
      exportMulti() {
        this.dialogContent = {
          title: '月份选择',
          componentName: 'month',
          width: '600px'
        }
        this.$refs.addDialog.show();
      },

      getOecStatus() {
        this.$ajax.get(this.$api.common.getDict, {ItemType: 'OecStatus'}).then((res) => {
          this.oecStatusList = res.data.rows || res.data || [];
        });
      },
      formatOecStatus(row) {
        const oecData = row.oecEntity || {};
        let status = this.oecStatusList.find(t => t.itemValue == oecData.status)
        return status ? status.itemDesc : '';
      },
      getImportanceList() {
        this.$ajax.get(this.$api.common.getDict, {ItemType: 'OECRecommendImportance'}).then((res) => {
          this.importanceList = res.data.rows || res.data || [];
        });
      },
      formatImportance(importance) {
        let res = this.importanceList.find(t => t.itemValue == importance)
        return res ? res.itemDesc : '';
      },

      downloadTemplate() {
        window.location.href = process.env.VUE_APP_PUBLICPATH + 'files/OEC建议申报导入模板.xlsx';
      },
      uploadPublishFile({ file }) {
        const params = new FormData();
        params.append('excelfile', file);
        this.$ajax.post(this.$api.manage.recommendDeclare.importFile, params, { headers: { 'Content-Type': 'multipart/form-data;' } }).then((res) => {
          if (res.code === 0) {
            this.$message.success('上传成功');
            this.getList(1);
          }
        });
      },
      declareExpandRowAll() {
        if (this.declareExpandRowAllFlag) {
          this.tableData.forEach(val => {
            val.expandRowFlag = false;
          });
        } else {
          this.tableData.forEach(val => {
            val.expandRowFlag = true;
          });
        }
        this.declareExpandRowAllFlag = !this.declareExpandRowAllFlag;
        this.$refs.unHandle.updateData(this.tableData);

        this.$nextTick(() => {
          if (this.$refs.unHandle) {
            let scrollInfo = this.$refs.unHandle.getScroll();
            this.$refs.unHandle.scrollTo(scrollInfo.scrollLeft, scrollInfo.scrollTop + 1);
          }
        });
      },
      historyExpandRowAll() {
        if (this.historyExpandRowAllFlag) {
          this.historyData.forEach(val => {
            val.expandRowFlag = false;
          });
        } else {
          this.historyData.forEach(val => {
            val.expandRowFlag = true;
          });
        }
        this.historyExpandRowAllFlag = !this.historyExpandRowAllFlag;
        this.$refs.handled.updateData(this.historyData);

        this.$nextTick(() => {
          if (this.$refs.handled) {
            let scrollInfo = this.$refs.handled.getScroll();
            this.$refs.handled.scrollTo(scrollInfo.scrollLeft, scrollInfo.scrollTop + 1);
          }
        });
      },
    },
    watch: {
      $route(){
        this.reload();
      },
      department: {
        handler(val) {
          const depTree = _.cloneDeep(this.copyTreeData);
          this.getChildrenMenu(depTree);
          if (!val) {
            this.departmentNo = "";
            this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
          }
        },
        immediate: true
      },
      historyDepartment: {
        handler(val) {
          this.$refs.historyTree && this.$refs.historyTree.filter(val);
          if (!val) {
            this.historyDepartmentNo = "";
            if (this.$refs.historyTree) {
              setTimeout(() => {
                const depTree = _.cloneDeep(this.historyCopyTreeData);
                this.historyTreeData = depTree;
              }, 10)
              this.$refs.historyTree.setCheckedKeys([]);
            }
          }
        },
        immediate: true
      },
    }
  }
</script>
<style scoped lang='scss'>
  .recommend-declare {
    .search-wrap {
      .atb-input {
        display: flex;
        .form-param-item {
          width: 20%;
          ::v-deep .el-form-item__content {
            width: calc(100% - 50px);
            .customerSelect {
              width: 100%;
            }
          }
        }
      }
    }
    .el-form-item.multi-line {
      ::v-deep .el-form-item__content {
        line-height: inherit;
      }
      .el-button.el-button--export, .el-button.el-button--downloadTemplate {
        width: 95px!important;
        white-space: normal;
        padding: 5px 2px;
        min-height: 40px;
      }
    }
    .search {
      .atb-input {
        display: flex;
        flex-direction: column;
        .query-where {
          display: flex;
          .flex-form-item {
            display: flex;
            flex: 1;
            margin-bottom: 12px;
          }
          ::v-deep.el-form-item__content {
            flex: 1;
            .el-select, .el-autocomplete, .el-date-editor {
              width: 100%;
            }
          }
        }
        .query-operation {
          display: flex;
        }
      }
    }
    height: 100%;
    .atb-content-bg {
      margin-top: 15px;
      padding: 20px;
      flex: 1;
    }
    ::v-deep .tab {
      margin-top: -3px;
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    .oec-result-status {
      margin: 0 10px;
    }
  }
</style>
<style>
  .declare-dep {
    height: 350px;
    width: 350px;
    overflow: auto;
  }
</style>